// extracted by mini-css-extract-plugin
export default {"container":"CardIndustry_container__hJZo6","image":"CardIndustry_image__c2WpZ","title":"CardIndustry_title__veZ5I"};